const VIDEO_INTERVIEW_CONTENT_PREVIEW_LENGTH = 512;

export { VIDEO_INTERVIEW_CONTENT_PREVIEW_LENGTH };
